import script from "./package-check.vue?vue&type=script&lang=ts&setup=true"
export * from "./package-check.vue?vue&type=script&lang=ts&setup=true"

import "./package-check.vue?vue&type=style&index=0&id=a2f33898&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2f33898"]])

export default __exports__